// extracted by mini-css-extract-plugin
module.exports = {"footerLinks":"dBWj7Cu9","collapse":"nu1eK5wI","link":"vEWeZ6GP"};